const getDefaultState = () => {
    return {
        file: {
            src: "",
            name: "",
            extention: "",
            downloadLink: "",
            error: {
                message: ''
            }
        },
    };
};

const officePreviewUrl = "https://view.officeapps.live.com/op/embed.aspx?src="
const officeExtentions = ["xlsx", "xls", "doc", "docx", "pptx", "ppt"]
const domainName = process.env.MIX_PRODUCTION_URL

const fileViewer = {
    namespaced: true,

    state: getDefaultState(),

    mutations: {
        SET_PROPERTIES(state, params) {
            state.file.extention = App.fileExtension(params.src);
            state.file.name = params.name;
            state.file.downloadLink = `${domainName}${params.src}`;

            if (officeExtentions.some(e => state.file.extention === e)) {
                state.file.src = `${officePreviewUrl}${domainName}${params.src}`
            } else {
                state.file.src = `${domainName}${params.src}`
            }
        },

        RESET(state) {
            Object.assign(state, getDefaultState())
        },

        SET_ERROR(state, message) {
            state.file.error.message = message
        }
    },

    actions: {
        viewFile({ commit }, params) {
            commit("SET_PROPERTIES", params);
        },

        error({ commit }, message) {
            commit("SET_ERROR", message)
        },

        reset({ commit }) {
            commit("RESET")
        },
    },

    getters: {
        file: state => state.file
    },
};

export default {
    ...fileViewer,
};
